import classnames from "classnames";
import url from "../../../module/fetch.tsx";
import { useGet } from "../../../components/Fetch/useFetch.tsx";
import Button from "../../../components/Button/Button.tsx";
import {
  FileInput,
  TextField,
  SelectInput,
  LargeTextField,
  CheckboxInput,
} from "../../../components/Form/Form.tsx";
import { IconReplace, IconSave } from "../../../components/Icon/Icon.tsx";
import EditModal from "../../../components/Modal/EditModal.tsx";
import { useModal } from "../../../components/Modal/Modal.tsx";
import { TypeRessourceEntity } from "../../../Entities/RessourceEntity.tsx";
import styles from "./EditRessource.module.css";

type EditRessourceType = {
  ressourceId: string;
  ressourceLibelle: string;
  ressourceDescription?: string;
  typeRessource: TypeRessourceEntity;
  typeRessourceId: string;
  ressourceTelechargeable: boolean;
  previewFile: any;
  file: any;
};

export const getInitialValues = (data: EditRessourceType) => ({
  ressourceId: data?.ressourceId ?? null,
  ressourceLibelle: data?.ressourceLibelle ?? "",
  ressourceDescription: data?.ressourceDescription ?? "",
  typeRessource: data?.typeRessource,
  ressourceTelechargeable: data?.ressourceTelechargeable,
  previewFile: undefined,
  file: undefined,
});
export const prepareVariables = (
  data: EditRessourceType,
  values: EditRessourceType,
) => {
  const formData = new FormData();
  formData.append("previewFile", values.previewFile ?? null);
  formData.append("file", values.file ?? null);
  formData.append("ressourceId", values.ressourceId);
  formData.append("ressourceLibelle", values.ressourceLibelle);
  formData.append("ressourceDescription", values.ressourceDescription);
  formData.append("typeRessourceId", values.typeRessource.typeRessourceId);
  formData.append("ressourceTelechargeable", values.ressourceTelechargeable);

  return formData;
};

const EditRessource = ({
  ressourceId,
  ressourceLibelle,
  ressourceDescription,
  typeRessourceId,
  ressourceTelechargeable,
}: EditRessourceType) => {
  const { visible, show, close } = useModal();

  const typeRessourceState = useGet(url`/api/type-ressource`);
  const typeRessource: TypeRessourceEntity =
    typeRessourceState?.data?.list.find(
      (e) => e.typeRessourceId === typeRessourceId,
    );
  const initValue: EditRessourceType = {
    ressourceId,
    ressourceLibelle,
    ressourceDescription,
    typeRessource,
    ressourceTelechargeable,
  };

  return (
    typeRessource != null && (
      <>
        <Button
          onClick={show}
          className={classnames(styles.cellButton, styles.previewCell)}
        >
          <IconReplace />
        </Button>
        <EditModal
          visible={visible}
          closeModal={close}
          loadData={false}
          isPost={false}
          id={ressourceId}
          query={url`/api/ressource/${ressourceId}/edit`}
          prepareVariables={prepareVariables}
          getInitialValues={getInitialValues(initValue)}
          onSubmit={() => window.location.reload(false)}
          header={"Modifier le contenu"}
          submitLabel={
            <div className={styles.iconSave}>
              Enregistrer les modifications &nbsp; <IconSave />
            </div>
          }
          isMultipartFormData={true}
        >
          <div className={styles.titleComponent}>
            <label htmlFor="ressourceLibelle" className={styles.titleInput}>
              Titre :
            </label>
            <TextField
              placeholder={ressourceLibelle}
              id="ressourceLibelle"
              name="ressourceLibelle"
            />
          </div>

          <label htmlFor="ressourceDescription" className={styles.description}>
            Description :
          </label>
          <LargeTextField
            placeholder={ressourceDescription}
            id="ressourceDescription"
            name="ressourceDescription"
            rows="5"
            cols="40"
          />
          <SelectInput
            label="Type de contenu"
            name="typeRessource"
            options={typeRessourceState.value?.list}
            getOptionValue={(t) => t.typeRessourceId}
            toOptionLabelFunc={(t) => t?.typeRessourceLibelle}
            isClearable={false}
            className={styles.selectInput}
          />
          <CheckboxInput
            label="Le fichier sera t-il téléchargeable ?"
            name="ressourceTelechargeable"
            value={ressourceTelechargeable}
          />
          <FileInput
            className={styles.inputLabel}
            name="previewFile"
            label={"Modifier l'image de preview"}
            accept={".png, .jpg, .jpeg"}
          />
          <FileInput
            className={styles.inputLabel}
            name="file"
            label={"Importer votre contenu"}
            accept={".wav, .mp4, .png, .jpg, .jpeg, .pdf"}
          />
        </EditModal>
      </>
    )
  );
};

export default EditRessource;
